import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';
import SimpleReactValidator from 'simple-react-validator';
import FetchCall from '../../API/FetchCall';
import { updateSplEvent, splEvent } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import swal from 'sweetalert';
import { Editor } from '@tinymce/tinymce-react';
import { Collapse, CardBody, Card, CardHeader } from 'reactstrap';
import { TINY_EDITOR } from '../../constant';
import ReactTooltip from "react-tooltip";
import EventPreview from './event_preview';

//$.DataTable = require('datatables.net')

const tabs = [{
  name: 'Event Information'
},
{
  name: 'Speaker Information'
},
{
  name: 'Form Information'
},
{
  name: 'CSS Information'
},
{
  name: `FAQ's`
},
{
  name: `Email Invite Information`
}]

class cmsEvents extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
               event_id: 0,
      start_date: '',
      end_date: '',
      meta_title: '',
      meta_desc: '',
      new_banner_image: '',
      tempBanner: '',
      img_url: '',
      event_title: '',
      event_content: '',
      ticker: '',
      speaker_details: [],
      registration_details:
      {
        form: [{
          lbl_name: 'Name',
          input_name: 'name',
          input_type: 'text',
          max_upload: '1',
        },
        {
          lbl_name: 'Email Address',
          input_name: 'email_id',
          input_type: 'email',
          max_upload: '1',
        },
        {
          lbl_name: 'Contact Number',
          input_name: 'mobile_number',
          input_type: 'number',
          max_upload: '1',
        },
        ],
        isForm: false
      },
      faq_details: [],
      page_css: {
        btn_css: {
          btn_bg_clr: '',
          btn_hvr_bg_clr: '',
          btn_font_clr: '',
          btn_hvr_font_clr: '',
          btn_hvr_bdr_clr: ''
        },
        form_css: {
          form_title: '',
          form_title_clr: '',
          form_bg_clr: '',
          form_bg_clr: '',
          sb_btn_bg_clr: '',
          sb_btn_value: '',
          sb_btn_font_clr: '',
        }
      },
      email_details: { data: {} },
      temp_ques: '',
      temp_ans: '',
      temp_fid: '',
      disableBtn: false,
      collapse: 'head-0',
    };
    this.validator = new SimpleReactValidator();
    this.eventList();

        
    }

  toggle(event) {
      this.setState({
        collapse: this.state.collapse === (event) ? -1 : (event)
      });
    }
    eventList = async () => {
      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role,
        path: window.location.pathname,
        url: 'get_event_list'
      });
      const res = await splEvent(ins);
      if (res.status == 1) {
        this.setState({
          write_permission: res.write_permission
        });
        this.datatabledata(res.list);
      }
    };


  datatabledata(data) {

    console.log('data', data)
    this.setState({
      dataSet: data
    })
    this.el = $(this.el)
    this.el.DataTable(
      {
        data: this.state.dataSet,
        columns: [
          { data: 'event_title' },
          { data: 'status' },
          { data: 'action' }
        ]

      }
    )
  }

  editEvent = (id) => {
    const { login_id, role } = this.state.auth_data;
    let req = JSON.stringify({
      event_id: id,
      role: 1,
      role: role,
      path: '/event_update',
      url: 'get_eventByid'
    });
    splEvent(req).then((res) => {
      if (res.status === 1) {
        const data = res.details;
        console.log('data.start_date', new Date(data.start_date))
        this.setState({
          event_id: data.id,
          meta_title: data.meta_title,
          meta_desc: data.meta_desc,
          start_date: data.start_date == '0000-00-00 00:00' ? '' : new Date(data.start_date),
          end_date: data.end_date == '0000-00-00 00:00' ? '' : new Date(data.end_date),
          c_banner_image: res.img_url + data.banner_image,
          img_url: res.img_url,
          event_title: data.event_title,
          event_content: data.event_content,
          ticker: data.ticker,
          email_details: data.email_details ? JSON.parse(data.email_details) : this.state.email_details,
          speaker_details: data.speaker_details ? JSON.parse(data.speaker_details) : [],
          registration_details: data.registration_details ? JSON.parse(data.registration_details) : [],
          faq_details: data.faq_details ? JSON.parse(data.faq_details) : [],
          page_css: data.page_css ? JSON.parse(data.page_css) : []
        })
      } else {
        setTimeout(function () {
          window.location.href = '/event_update';
        }, 1000);
      }
    })
  }

    componentDidMount() {

      const { role } = this.state.auth_data;
      if (role == 1) {
        this.setState({
          write_permission: true
        })
      }
      let qrystr = window.location.search;
      const urlParams = new URLSearchParams(qrystr);
      let event_id = urlParams.get('id');
      if (event_id)
        this.editEvent(event_id);
      var THIS = this;
      $(document).on('click', '.delete_event', function () {
        var delete_id = $(this).data("id");
        THIS.setState({
          delete_id: delete_id
        });
        THIS.deleteEvent(delete_id);
      });

    }

  componentDidUpdate() {
    
  }

  handleChange = (e) => {
    const propName = e.target.name;
    const propValue = e.target.value;
    this.setState({
      [propName]: propValue
    })
  }
  handleChangeSpeaker = (e, i) => {
    const type = e.target.type;
    const propName = e.target.name;
    let propValue;
    if (type == 'text' || type == 'textarea' || type == 'select-one')
      propValue = e.target.value;
    if (type == 'file') {
      propValue = e.target.files[0];
      let THIS = this;
      const reader = new FileReader();
      if (propValue)
        reader.readAsDataURL(propValue);
      reader.addEventListener("load", function () {
        // convert image file to base64 string
        let speaker_details = THIS.state.speaker_details;
        speaker_details[i]['temp_img'] = reader.result;
        THIS.setState({
          speaker_details
        })
      }, false);
    }
    let speaker_details = this.state.speaker_details;
    speaker_details[i][propName] = propValue;
    this.setState({
      speaker_details
    })
  }
  handleChangeFaq = (e, i) => {
    const propName = e.target.name;
    let propValue = e.target.value;
    let faq_details = this.state.faq_details;
    faq_details[i][propName] = propValue;
    this.setState({
      faq_details
    })
  }
  handleChangeEmail = (e, i) => {
    const propName = e.target.name;
    let propValue = e.target.value;
    let email_details = this.state.email_details;
    email_details.data[propName] = propValue;
    this.setState({
      email_details
    })
  }
  handleChangeEmailEditor = (value, editor) => {
    let email_details = this.state.email_details;
    email_details.data[editor.targetElm.name] = value;
    this.setState({
      email_details
    });
  }
  handleFileBanner = (e) => {
    const propName = e.target.name;
    const files = e.target.files[0];
    this.setState({
      [propName]: files
    });
    let THIS = this;
    const reader = new FileReader();
    if (files)
      reader.readAsDataURL(files);
    reader.addEventListener("load", function () {
      // convert image file to base64 string
      // img = reader.result;
      THIS.setState({
        tempBanner: reader.result
      });
    }, false);
    // var img = new Image();
    // img.src = window.URL.createObjectURL(files);
    // img.onload = function () {
    //   var width = img.naturalWidth,
    //     height = img.naturalHeight;
    //   if (width == 1350 && height == 468)
    //     THIS.setState({
    //       [propName]: files
    //     });
    //   else
    //     THIS.setState({
    //       [propName]: ''
    //     });
    //   window.URL.revokeObjectURL(img.src);
    // };
  };
  handleEditorChange = (value, editor) => {
    this.setState({
      [editor.targetElm.name]: value
    });
  }
  handleEditorChangeFaq = (value, editor) => {
    let faq_details = this.state.faq_details;
    let id = parseInt(editor.id) - 1;
    let name = editor.targetElm.name;
    faq_details[id][name] = value;
    this.setState({
      faq_details
    });
  }
  handleChangeCss = (e, type) => {
    let page_css = this.state.page_css;
    const propName = e.target.name;
    const propValue = e.target.value;
    if (type == 1) {
      page_css.btn_css[propName] = propValue;
    }
    if (type == 2) {
      page_css.form_css[propName] = propValue;
    }
    this.setState({
      page_css
    })
  }
  handleFormCheckBox = () => {
    let registration_details = this.state.registration_details;
    registration_details.isForm = !registration_details.isForm;
    this.setState({
      registration_details
    })
  }
  handleFormChange = (e, i) => {
    const propName = e.target.name;
    const propValue = e.target.value;
    let registration_details = this.state.registration_details;
    registration_details.form[i][propName] = propValue;
    this.setState({
      registration_details
    })
  }
    render() {

     const { collapse, speaker_details, page_css, registration_details,
      faq_details, write_permission } = this.state;
    const { login_id, role } = this.state.auth_data;
    const { btn_css, form_css } = page_css;
    const email_details = this.state.email_details.data;
    this.validator.purgeFields();
    console.log('email_details', JSON.stringify(this.state.email_details));

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Events</h4>
                 
 
                    <div class="row">
                      
                        <div class="col-lg-12">

                           <div className="main-content col-md-12 col-xs-12">
                <div className="box-shadow-custom spl-event-box">
                  <div className='row'>
                    <div className='col-md-12'>
                      <Card className='panel-group custom-card' style={{ marginBottom: '1rem' }} key={'head-0'}>
                        <CardHeader onClick={() => this.toggle('head-0')} data-event={'head-0'} className='custom-card-heading'>
                          <b>{'Event List'}</b>
                          {collapse != 'head-0' ? (
                            <span className='pull-right'>
                              <i class="fa fa-plus" aria-hidden="true"></i>
                            </span>
                          ) : (
                            <span className='pull-right'>
                              <i class="fa fa-minus" aria-hidden="true"></i>
                            </span>
                          )}
                        </CardHeader>
                        <Collapse isOpen={collapse == 'head-0'}>
                          <CardBody className='panel-body'>
                            <div className="table-responsive content-sec col-md-12 col-xs-12 pad-no mar-t-no">
                              <table className="table table-custom-design table-striped dataTable event-table" ref={el => this.el = el}>
                                <thead className=''>
                                  <tr role="row">
                                    <th className="tabledata">Event Title</th>
                                    <th className="tabledata">Status</th>
                                    <th className="tabledata">Action</th>
                                  </tr>
                                </thead>
                              </table>
                            </div>
                          </CardBody>
                        </Collapse>
                      </Card>
                    </div>
                  </div>
                </div>
                {write_permission && (
                  <React.Fragment >
                    <div className="hdr-row">
                      <h4 className="fw-sbold mar-t-no">Special Events</h4>
                      {write_permission && this.state.event_id > 0 && (
                        <div className="pull-right">
                          <div className="dropdown menu-item">
                            <a href='/event_update' className="btn btn-green dropdown-toggle btn-arrow btn-circle">
                              <i className="fa fa-plus-circle" aria-hidden="true"></i> Add New Event
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="box-shadow-custom spl-event-box">
                      <form autoComplete='off' id='package_form'>
                        {tabs.map((item, index) => {
                          console.log('index', index, btn_css)
                          return (
                            <Card className='panel-group custom-card' style={{ marginBottom: '1rem' }} key={index}>
                              <CardHeader onClick={() => this.toggle(index)} data-event={index} className='custom-card-heading'>
                                <b>{item.name}</b>
                                {collapse !== index ? (
                                  <span className='pull-right'>
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                  </span>
                                ) : (
                                  <span className='pull-right'>
                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                  </span>
                                )}
                              </CardHeader>
                              <Collapse isOpen={collapse === index}>
                                <CardBody className='panel-body'>
                                  {index === 0 && (
                                    <React.Fragment>
                                      <div className="row">
                                        <div class="form-group custom-form-group col-md-6">
                                          <label> Title <span className="astrick">*</span></label>
                                          <input type='text' className='form-control' name='event_title'
                                            value={this.state.event_title} onChange={this.handleChange} />
                                          {this.validator.message('Title', this.state.event_title, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-6">
                                          <label> Banner&nbsp;<i class="fa fa-info-circle info-tool" data-tip data-for="info" aria-hidden="true"></i> <span className="astrick">*</span>
                                            <ReactTooltip id="info" place="bottom" effect="solid" className='react_tooltip_backgrnd'>
                                              <p>Banner size should be 1350*468</p>
                                            </ReactTooltip>
                                          </label>
                                          <input type='file' accept='images/*' className='form-control' name='new_banner_image'
                                            onChange={this.handleFileBanner} />
                                          {this.state.event_id == 0 && this.validator.message('Banner', this.state.new_banner_image, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-6 cus-date-sec">
                                          <label> Start Date <span className="astrick">*</span></label>
                                          <DatePicker
                                            autocomplete="off"
                                            className='form-control input-group-date'
                                            selected={this.state.start_date}
                                            showTimeSelect
                                            name="start_date"
                                            id="start_date"
                                            timeIntervals={5}
                                            dateFormat="MMMM d, yyyy HH:mm"
                                            onChange={(date) => {
                                              this.setState({
                                                start_date: date
                                              })
                                            }}
                                          />
                                          {this.validator.message('Start Date', this.state.start_date, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-6 cus-date-sec">
                                          <label> End Date <span className="astrick">*</span></label>
                                          <DatePicker
                                            autocomplete="off"
                                            timeIntervals={5}
                                            className='form-control input-group-date'
                                            selected={this.state.end_date}
                                            name="end_date"
                                            id="end_date"
                                            showTimeSelect
                                            dateFormat="MMMM d, yyyy HH:mm"
                                            onChange={(date) => {
                                              this.setState({
                                                end_date: date
                                              })
                                            }}
                                          />
                                          {this.validator.message('End Date', this.state.end_date, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-6">
                                          <label> Meta Title <span className="astrick">*</span></label>
                                          <input type='text' className='form-control' name='meta_title'
                                            value={this.state.meta_title} onChange={this.handleChange} />
                                          {this.validator.message('Meta Title', this.state.meta_title, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-6">
                                          <label> Meta Description <span className="astrick">*</span></label>
                                          <textarea type='text' rows={2} className='form-control' name='meta_desc'
                                            value={this.state.meta_desc} onChange={this.handleChange} />
                                          {this.validator.message('Meta Description', this.state.meta_desc, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-6">
                                          <label> Ticker <span className="astrick">*</span></label>
                                          <input type='text' rows={2} className='form-control' name='ticker'
                                            value={this.state.ticker} onChange={this.handleChange} />
                                          {this.validator.message('Ticker', this.state.ticker, 'required', { className: 'text-danger' })}
                                        </div>
                                      </div>
                                      <div className='row'>
                                        <div class="form-group custom-form-group col-md-12">
                                          <label> Event Content <span className="astrick">*</span></label>
                                          <Editor
                                            textareaName='event_content'
                                            onEditorChange={this.handleEditorChange}
                                            value={this.state.event_content}
                                            apiKey={TINY_EDITOR}
                                            init={{
                                              height: 500,
                                              plugins: [
                                                'lists link image paste'
                                              ],
                                              menubar: 'edit | insert | format',
                                              toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link'
                                            }}
                                          />
                                          {this.validator.message('Event Content', this.state.event_content, 'required', { className: 'text-danger' })}
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  )}
                                  {index === 1 && (
                                    <React.Fragment>
                                      <div className='row'>
                                        <div className='col-md-12'>
                                          <button className='btn btn-primary btn-sm pull-right'
                                            onClick={this.addSpeaker}>Add</button>
                                        </div>
                                        {speaker_details.map((item, i) => {
                                          let cnt = i + 1;
                                          return (
                                            <React.Fragment>
                                              <div className='row'>
                                                <div className='form-group custom-form-group col-md-6'>
                                                  <h4>Speaker {cnt}</h4>
                                                </div>
                                                <div className='form-group custom-form-group col-md-6'>
                                                  <button className='btn btn-danger btn-sm pull-right'
                                                    onClick={(e) => this.removeSpeaker(e, i)}>Remove</button>
                                                </div>
                                              </div>
                                              <div className='row'>
                                                <div class="form-group custom-form-group col-md-6">
                                                  <label> Name <span className="astrick">*</span></label>
                                                  <div className='row'>
                                                    <div className='col-md-3'>
                                                      <select title='Select' onChange={(e) => this.handleChangeSpeaker(e, i)}
                                                        className='selectpicker form-control' name='spk_title'
                                                        value={item.spk_title}>
                                                        <option value={'Mr.'}>Mr.</option>
                                                        <option value={'Ms.'}>Ms.</option>
                                                        <option value={'Dr.'}>Dr.</option>
                                                        <option value={'Prof.'}>Prof.</option>
                                                      </select>
                                                      {this.validator.message('', item.spk_title, 'required', { className: 'text-danger' })}
                                                    </div>
                                                    <div className='col-md-9'>
                                                      <input type='text' className='form-control' name='spk_name'
                                                        value={item.spk_name} onChange={(e) => this.handleChangeSpeaker(e, i)} />
                                                      {this.validator.message('Name', item.spk_name, 'required', { className: 'text-danger' })}
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="form-group custom-form-group col-md-6">
                                                  <label> Profile Image <span className="astrick">*</span></label>
                                                  <input type='file' className='form-control' name='spk_img'
                                                    onChange={(e) => this.handleChangeSpeaker(e, i)} />
                                                  {this.state.event_id == 0 && this.validator.message('Profile Image', item.spk_img, 'required', { className: 'text-danger' })}
                                                </div>
                                                <div class="form-group custom-form-group col-md-6">
                                                  <label> Short Description <span className="astrick">*</span></label>
                                                  <textarea type='text' rows={3} className='form-control' name='spk_desc'
                                                    value={item.spk_desc} onChange={(e) => this.handleChangeSpeaker(e, i)} />
                                                  {this.validator.message('Short Description', item.spk_desc, 'required', { className: 'text-danger' })}
                                                </div>
                                              </div>
                                            </React.Fragment>
                                          )
                                        })}
                                      </div>
                                    </React.Fragment>
                                  )}
                                  {index === 2 && (
                                    <React.Fragment>
                                      <div className="row">
                                        <div class="form-group custom-form-group col-md-3">
                                          <label> Is Form Required <span className="astrick">*</span></label>
                                        </div>
                                        <div class="form-group custom-form-group col-md-2">
                                          <input type='checkbox' name='isform' checked={registration_details.isForm}
                                            className='form-control checkbox-cus' onClick={this.handleFormCheckBox} />
                                        </div>
                                        <div className="form-group custom-form-group col-md-7">
                                          <button className='btn btn-primary btn-sm pull-right'
                                            onClick={this.addFormField}>Add</button>
                                        </div>
                                      </div>
                                      {registration_details.isForm && (
                                        <div className="row">
                                          <div className='form-group custom-form-group col-md-12 table'>
                                            <table className='table table-bordered'>
                                              <tr>
                                                <th>Label Name</th>
                                                <th>Input Name</th>
                                                <th>Type</th>
                                                <th>Max Upload Count</th>
                                                <th>Action</th>
                                              </tr>
                                              {registration_details.form.map((item, i) => {
                                                return (
                                                  <tr className='cu-row'>
                                                    <td>
                                                      <input type='text' className='form-control' disabled={i < 3}
                                                        name='lbl_name' onChange={(e) => this.handleFormChange(e, i)} value={item.lbl_name} />
                                                    </td>
                                                    <td>
                                                      <input type='text' className='form-control' name='input_name'
                                                        onChange={(e) => this.handleFormChange(e, i)} value={item.input_name} disabled={i < 3} />
                                                    </td>
                                                    <td>
                                                      <select className='form-control selectpicker' value={item.input_type}
                                                        onChange={(e) => this.handleFormChange(e, i)} name='input_type' title='Select'
                                                        disabled={i < 3}>
                                                        <option value={'text'}>Text</option>
                                                        <option value={'email'}>Email</option>
                                                        <option value={'number'}>Number</option>
                                                        <option value={'file'}>Files</option>
                                                      </select>
                                                    </td>
                                                    <td>
                                                      <input type='text' className='form-control' name='max_upload'
                                                        onChange={(e) => this.handleFormChange(e, i)} value={item.max_upload}
                                                        disabled={item.input_type != 'file' || i < 3} />
                                                    </td>
                                                    <td>
                                                      {i > 2 &&
                                                        (
                                                          <button className='btn btn-danger btn-sm pull-right'
                                                            onClick={(e) => this.removeFormField(e, i)}>
                                                            <i class="fa fa-trash" aria-hidden="true" ></i>
                                                          </button>
                                                        )
                                                      }
                                                    </td>
                                                  </tr>
                                                )
                                              })}
                                            </table>
                                          </div>
                                        </div>
                                      )}
                                    </React.Fragment>
                                  )}
                                  {index === 3 && registration_details.isForm && (
                                    <React.Fragment>
                                      <div className='row'>
                                        <div className='form-group custom-form-group col-md-12'>
                                          <h4>Top Button CSS</h4>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div class="form-group custom-form-group col-md-4">
                                          <label> BG Color <span className="astrick">*</span></label>
                                          <input type='color' className='form-control' name='btn_bg_clr'
                                            value={btn_css.btn_bg_clr} onChange={(e) => this.handleChangeCss(e, 1)} />
                                          {this.validator.message('BG Color', btn_css.btn_bg_clr, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-4">
                                          <label> Hover BG Color <span className="astrick">*</span></label>
                                          <input type='color' className='form-control' name='btn_hvr_bg_clr'
                                            value={btn_css.btn_hvr_bg_clr} onChange={(e) => this.handleChangeCss(e, 1)} />
                                          {this.validator.message('Hover BG Color', btn_css.btn_hvr_bg_clr, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-4">
                                          <label> Font Color <span className="astrick">*</span></label>
                                          <input type='color' className='form-control' name='btn_font_clr'
                                            value={btn_css.btn_font_clr} onChange={(e) => this.handleChangeCss(e, 1)} />
                                          {this.validator.message('Font Color', btn_css.btn_font_clr, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-4">
                                          <label> Hover Font Color <span className="astrick">*</span></label>
                                          <input type='color' className='form-control' name='btn_hvr_font_clr'
                                            value={btn_css.btn_hvr_font_clr} onChange={(e) => this.handleChangeCss(e, 1)} />
                                          {this.validator.message('Hover Font Color', btn_css.btn_hvr_font_clr, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-4">
                                          <label> Hover Border Color <span className="astrick">*</span></label>
                                          <input type='color' className='form-control' name='btn_hvr_bdr_clr'
                                            value={btn_css.btn_hvr_bdr_clr} onChange={(e) => this.handleChangeCss(e, 1)} />
                                          {this.validator.message('Hover Border Color', btn_css.btn_hvr_bdr_clr, 'required', { className: 'text-danger' })}
                                        </div>
                                      </div>
                                      <div className='row'>
                                        <div className='form-group custom-form-group col-md-12'>
                                          <h4>Registration Form</h4>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div class="form-group custom-form-group col-md-4">
                                          <label> Form Title <span className="astrick">*</span></label>
                                          <input type='text' className='form-control' name='form_title'
                                            value={form_css.form_title} onChange={(e) => this.handleChangeCss(e, 2)} />
                                          {this.validator.message('Form Title', form_css.form_title, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-4">
                                          <label> Font Color <span className="astrick">*</span></label>
                                          <input type='color' className='form-control' name='form_title_clr'
                                            value={form_css.form_title_clr} onChange={(e) => this.handleChangeCss(e, 2)} />
                                          {this.validator.message('Font Color', form_css.form_title_clr, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-4">
                                          <label> Form BG Color <span className="astrick">*</span></label>
                                          <input type='color' className='form-control' name='form_bg_clr'
                                            value={form_css.form_bg_clr} onChange={(e) => this.handleChangeCss(e, 2)} />
                                          {this.validator.message('Form BG Color', form_css.form_bg_clr, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-4">
                                          <label> Button BG Color <span className="astrick">*</span></label>
                                          <input type='color' className='form-control' name='sb_btn_bg_clr'
                                            value={form_css.sb_btn_bg_clr} onChange={(e) => this.handleChangeCss(e, 2)} />
                                          {this.validator.message('Button BG Color', form_css.sb_btn_bg_clr, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-4">
                                          <label> Button Font Color <span className="astrick">*</span></label>
                                          <input type='color' className='form-control' name='sb_btn_font_clr'
                                            value={form_css.sb_btn_font_clr} onChange={(e) => this.handleChangeCss(e, 2)} />
                                          {this.validator.message('Button BG Color', form_css.sb_btn_font_clr, 'required', { className: 'text-danger' })}
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  )}
                                  {index === 4 && (
                                    <React.Fragment>
                                      <div className='row'>
                                        {/* <div className='col-md-12'>
                                      <button className='btn btn-primary btn-sm pull-right'
                                        onClick={this.addFaq}>Add</button>
                                    </div> */}
                                        <div className='row'>
                                          <div className='form-group custom-form-group col-md-12 table'>
                                            <table className='table table-bordered'>
                                              <tbody>
                                                <tr>
                                                  <th>No</th>
                                                  <th>Question</th>
                                                  <th style={{ width: '15%' }}>Action</th>
                                                </tr>
                                              </tbody>
                                              <tbody>
                                                {faq_details.map((item, i) => {
                                                  let cnt = i + 1;
                                                  return (
                                                    <tr>
                                                      <td>{cnt}</td>
                                                      <td>{item.ques}</td>
                                                      <td>
                                                        <div className='row'>
                                                          <div className='col-md-6'>
                                                            <button className='btn btn-primary btn-sm pull-right'
                                                              onClick={(e) => this.editFaq(e, i)}>
                                                              <i class="fa fa-edit" aria-hidden="true"></i>
                                                            </button>
                                                          </div>
                                                          <div className='col-md-6'>
                                                            <button className='btn btn-danger btn-sm pull-right'
                                                              onClick={(e) => this.removeFaq(e, i)}>
                                                              <i class="fa fa-times" aria-hidden="true"></i>
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  )
                                                })}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                        <div className='row'>
                                          <div class="form-group custom-form-group col-md-12">
                                            <label> Question <span className="astrick">*</span></label>
                                            <input type='text' className='form-control' name='temp_ques'
                                              value={this.state.temp_ques} onChange={this.handleChange} />
                                            <label> Answer <span className="astrick">*</span></label>
                                            <Editor
                                              textareaName='temp_ans'
                                              onEditorChange={this.handleEditorChange}
                                              value={this.state.temp_ans}
                                              apiKey={TINY_EDITOR}
                                              init={{
                                                height: 300,
                                                plugins: [
                                                  'lists link image paste'
                                                ],
                                                menubar: 'edit | insert | format',
                                                toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link'
                                              }}
                                            />
                                          </div>
                                        </div>
                                        <div className='row'>
                                          <div class="form-group custom-form-group col-md-12">
                                            <button className='btn btn-danger btn-sm pull-right'
                                              onClick={this.cancelFaq}><i class="fa fa-times" aria-hidden="true"></i></button>
                                            <button className='btn btn-primary btn-sm pull-right' style={{ marginRight: '20px' }}
                                              onClick={this.addFaq}><i class="fa fa-check" aria-hidden="true"></i></button>
                                          </div>
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  )}
                                  {index === 5 && registration_details.isForm && (
                                    <React.Fragment>
                                      <div className="row">
                                        <div class="form-group custom-form-group col-md-6">
                                          <label> Subject <span className="astrick">*</span></label>
                                          <input type='text' className='form-control' name='subject'
                                            value={email_details.subject} onChange={this.handleChangeEmail} />
                                          {this.validator.message('Title', email_details.subject, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-6 cus-date-sec">
                                          <label> Event Date Time <span className="astrick">*</span></label>
                                          <DatePicker
                                            autocomplete="off"
                                            className='form-control input-group-date'
                                            selected={email_details.eventdate ? new Date(email_details.eventdate) : ''}
                                            name="eventdate"
                                            id="eventdate"
                                            showTimeSelect
                                            dateFormat="MMMM d, yyyy HH:mm"
                                            onChange={(date) => {
                                              let email_details = this.state.email_details;
                                              email_details.data['eventdate'] = (date);
                                              this.setState({
                                                email_details
                                              })
                                            }}
                                          />
                                          {this.validator.message('Event Date', email_details.eventdate, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-6">
                                          <label> Duration<span className="astrick">*</span></label>
                                          <input type='text' className='form-control' name='duration' placeholder='HH:MM'
                                            value={email_details.duration} onChange={this.handleChangeEmail} />
                                          {this.validator.message('Duration', email_details.duration, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-6">
                                          <label> Calender Title<span className="astrick">*</span></label>
                                          <input type='text' className='form-control' name='calender_title'
                                            value={email_details.calender_title} onChange={this.handleChangeEmail} />
                                          {this.validator.message('Calender Title', email_details.calender_title, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-6">
                                          <label> Calender Short Description <span className="astrick">*</span></label>
                                          <textarea type='text' rows={2} className='form-control' name='calender_desc'
                                            value={email_details.calender_desc} onChange={this.handleChangeEmail} />
                                          {this.validator.message('Calender Short Description', email_details.calender_desc, 'required', { className: 'text-danger' })}
                                        </div>
                                        <div class="form-group custom-form-group col-md-6">
                                          <label> URL <span className="astrick">*</span></label>
                                          <input type='text' className='form-control' name='event_url'
                                            value={email_details.event_url} onChange={this.handleChangeEmail} />
                                          {this.validator.message('Ticker', email_details.event_url, 'required', { className: 'text-danger' })}
                                        </div>
                                      </div>
                                      <div className='row'>
                                        <div class="form-group custom-form-group col-md-12">
                                          <label> Email Body <span className="astrick">*</span></label>
                                          <Editor
                                            textareaName='mail_body'
                                            onEditorChange={this.handleChangeEmailEditor}
                                            value={email_details.mail_body}
                                            apiKey={TINY_EDITOR}
                                            init={{
                                              height: 500,
                                              plugins: [
                                                'lists link image paste'
                                              ],
                                              menubar: 'edit | insert | format',
                                              toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link'
                                            }}
                                          />
                                          {this.validator.message('Email Body', email_details.mail_body, 'required', { className: 'text-danger' })}
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  )}
                                </CardBody>
                              </Collapse>
                            </Card>
                          )
                        })}
                        <Card className='panel-group custom-card' style={{ marginBottom: '1rem' }} key={'preview'}>
                          <CardHeader onClick={() => this.toggle('preview')} data-event={'preview'} className='custom-card-heading'>
                            <b>{'Preview'}</b>
                            {collapse != 'preview' ? (
                              <span className='pull-right'>
                                <i class="fa fa-plus" aria-hidden="true"></i>
                              </span>
                            ) : (
                              <span className='pull-right'>
                                <i class="fa fa-minus" aria-hidden="true"></i>
                              </span>
                            )}
                          </CardHeader>
                          <Collapse isOpen={collapse == 'preview'}>
                            <CardBody className='panel-body'>
                              <EventPreview eData={this.state} />
                            </CardBody>
                          </Collapse>
                        </Card>
                        <div className="row mb-4">
                          <div className='col-md-12'>
                            {role == 1 && (
                              <button type='submit' onClick={(e) => this.handleSubmit(e, 1)} disabled={this.state.disableBtn}
                                className="btn btn-primary btn-sm pull-right">
                                Submit
                              </button>
                            )}
                            <button type='submit' onClick={(e) => this.handleSubmit(e, 2)} style={{ marginRight: '20px' }} disabled={this.state.disableBtn}
                              className="btn btn-primary btn-sm pull-right">
                              Save
                            </button>
                          </div>

                        </div>
                      </form>
                    </div>
                  </React.Fragment >
                )}
              </div>


                        </div>

                    </div>
                  

              
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }


      handleSubmit = (e, type) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      let formData = new FormData();
      formData.append('event_id', this.state.event_id);
      formData.append('status', type);
      formData.append('meta_title', this.state.meta_title);
      formData.append('meta_desc', this.state.meta_desc);
      formData.append('start_date', this.state.start_date);
      formData.append('end_date', this.state.end_date);
      formData.append('new_banner_image', this.state.new_banner_image);
      formData.append('event_title', this.state.event_title);
      formData.append('event_content', this.state.event_content);
      formData.append('ticker', this.state.ticker);
      formData.append('speaker_details', JSON.stringify(this.state.speaker_details));
      let spkData = this.state.speaker_details;
      if (spkData.length > 0) {
        for (let i = 0; i < spkData.length; i++) {
          formData.append(`spk_img`, spkData[i].spk_img);
        }
      }
      formData.append('registration_details', JSON.stringify(this.state.registration_details));
      formData.append('faq_details', JSON.stringify(this.state.faq_details));
      formData.append('page_css', JSON.stringify(this.state.page_css));
      formData.append('email_details', JSON.stringify(this.state.email_details));
      updateSplEvent(formData).then((response) => {
        let toastr = '';
        if (response.status === 1) {
          toastr = window.toastr.success;
          toastr('Success', response.message, {
            positionClass: "toast-bottom-right",
            containerId: "toast-bottom-right"
          });
          setTimeout(function () {
            window.location.href = '/event_update';
          }, 1000);
        } else {
          toastr = window.toastr.error; //warning
          toastr('', response.message, {
            positionClass: "toast-bottom-right",
            containerId: "toast-bottom-right"
          });
        }
      })
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }
  addSpeaker = (e) => {
    e.preventDefault();
    this.setState(({
      speaker_details: [...this.state.speaker_details, { spk_title: '', spk_name: "", spk_desc: "", spk_img: "" }]
    }))
  }
  removeSpeaker = (e, i) => {
    e.preventDefault();
    let speaker_details = this.state.speaker_details;
    speaker_details.splice(i, 1);
    this.setState({ speaker_details });
  }
  cancelFaq = (e) => {
    e.preventDefault();
    this.setState({ temp_ans: '', temp_ques: '', temp_fid: '' })
  }
  addFaq = (e) => {
    e.preventDefault();
    const { temp_ans, temp_fid, temp_ques, faq_details } = this.state;
    if (temp_ques && temp_ans) {
      if (parseInt(temp_fid) >= 0) {
        faq_details[temp_fid]['ques'] = temp_ques;
        faq_details[temp_fid]['ans'] = temp_ans;
      } else {
        faq_details.push({
          ques: temp_ques,
          ans: temp_ans
        })
      }
      console.log('faq_details', faq_details)
      this.setState({ faq_details: faq_details, temp_ans: '', temp_ques: '', temp_fid: '' })
    } else {
      let toastr = '';
      toastr = window.toastr.error; //warning
      toastr('', 'Question/ Answer Fields Required', {
        positionClass: "toast-bottom-right",
        containerId: "toast-bottom-right"
      });
    }
  }
  editFaq = (e, i) => {
    e.preventDefault();
    const { faq_details } = this.state;
    this.setState({ temp_ans: faq_details[i]['ans'], temp_ques: faq_details[i]['ques'], temp_fid: i })
  }
  removeFaq = (e, i) => {
    e.preventDefault();
    let faq_details = this.state.faq_details;
    faq_details.splice(i, 1);
    this.setState({ faq_details });
  }
  addFormField = (e) => {
    e.preventDefault();
    let registration_details = this.state.registration_details;
    registration_details.form.push(
      {
        lbl_name: '',
        input_name: '',
        input_type: '',
        max_upload: '1',
      },
    )
    this.setState(({
      registration_details
    }))
  }
  removeFormField = (e, i) => {
    e.preventDefault();
    let registration_details = this.state.registration_details;
    registration_details.form.splice(i, 1);
    this.setState({ registration_details });
  }
  deleteEvent(delete_id = '') {
    swal({
      title: "Are you sure to Disable Event?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        let ins = JSON.stringify({
          event_id: delete_id ? delete_id : this.state.delete_id,
          role: this.state.role,
          url: 'remove_event'
        });
        splEvent(ins).then((res) => {
          let toastr = '';
          if (res.status === 1) {
            toastr = window.toastr.success;
            toastr('', res.message, {
              positionClass: "toast-bottom-right",
              containerId: "toast-bottom-right"
            });
            setTimeout(function () {
              window.location.reload();
            }, 2000);
          } else {
            toastr = window.toastr.error; //warning
            toastr('', res.message, {
              positionClass: "toast-bottom-right",
              containerId: "toast-bottom-right"
            });
          }
        });
      }
    });
  }

}


export default cmsEvents;


// WEBPACK FOOTER //
// ./src/components/bewise/cmsEvents.jsx